import { api } from './api'

export const createSession = async (email, password) => {
  const token = localStorage.getItem('token')
  const headers = {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  }

  return api.post('/sessions', { email, password }, { headers })
}
